/* eslint-disable max-len, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, no-nested-ternary, no-return-assign, react/no-array-index-key, react/state-in-constructor */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Icon, Spin, Tooltip } from 'antd';
import Moment from 'react-moment';
import { mot_titles } from '../statics';
import { getLeadsMotHistoryRequest } from '../../redux/actions/get_leads_mot_history.actions';
import { checkLeadReject } from '../../../../../shared/helpers';
import Table from '../../../../../components/table/Table';

class MotHistory extends Component {
    state = {
        part_history: 9999,
    };

    retrieveMOTHistory = () => this.props.dispatch(getLeadsMotHistoryRequest(this.props.bike_details));

    showAllMotHistory = () => this.setState({ part_history: this.props.mot_history.length });

    hideAllMotHistory = () => this.setState({ part_history: 4 });

    showFailReason = (comment) => {
        let reason = '';
        if (comment) {
            comment.forEach((item) => reason += `${item.text};`);
        }
        return reason;
    };

    renderResultCell(item) {
        if (!item.result) {
            return '-';
        }

        if (item.result === 'FAILED') {
            return (
                <Tooltip trigger="click" title={this.showFailReason(item.comment)}>
                    <span className="badge badge-suspended">{item.result}</span>
                </Tooltip>
            );
        }

        if (item.result === 'RECALL') {
            return <span className="badge badge-pending">{item.result}</span>;
        }

        return <span className="badge">{item.result}</span>;
    }

    renderMotHistoryAction(mot_history, _id) {
        if (!mot_history.length) {
            return checkLeadReject(_id) && (
                <span className="select_manually" onClick={this.retrieveMOTHistory}>
                    <Icon type="edit" style={{ paddingRight: '5px' }} />
                    Retrieve MOT
                </span>
            );
        }

        if (mot_history.length > 4 && this.state.part_history === 4) {
            return (
                <>
                    <span className="select_manually" onClick={this.retrieveMOTHistory}>Re-Run MOT</span>
                    {' '}
                    <span className="select_manually">&bull;</span>
                    <span className="select_manually" onClick={this.showAllMotHistory}> See Full History</span>
                </>
            );
        }

        if (this.state.part_history > 4) {
            return (
                <>
                    <span className="select_manually" onClick={this.retrieveMOTHistory}>Re-Run MOT</span>
                    {' '}
                    <span className="select_manually">&bull;</span>
                    <span className="select_manually" onClick={this.hideAllMotHistory}> Hide Full History</span>
                </>
            );
        }

        return <span className="select_manually" onClick={this.retrieveMOTHistory}>Re-Run MOT</span>;
    }

    render() {
        const { mot_history, _id, bike_details } = this.props;

        let cutedMotHistory = [];
        let latest_mot_mileage = 0;
        let is_clocked = false;
        let hasRecall = false;

        if (mot_history) {
            cutedMotHistory = mot_history.slice(0, this.state.part_history);

            latest_mot_mileage = cutedMotHistory.length > 0 ? cutedMotHistory[0].mileage : 0;
            is_clocked = cutedMotHistory.some((item) => latest_mot_mileage < item.mileage);
            hasRecall = mot_history.some((item) => item.result === 'RECALL');
        }

        return (
            <Spin spinning={this.props.loading} tip="MOT History loading ...">
                <div className="profile__information cap">
                    {
                        (mot_history === null || mot_history === undefined)
                        && (
                            <>
                                <h3>
                                    MOT History
                                    <span className="select_manually" onClick={this.retrieveMOTHistory}>
                                        <Icon type="edit" style={{ paddingRight: '5px' }} />
                                        Retrieve MOT
                                    </span>
                                </h3>
                                <p>NO MOT has been returned for this lead. Click to retrieve the MOT</p>
                            </>
                        )
                    }
                    {
                        mot_history && (
                            <div className="profile__data valuation">
                                <h3>
                                    MOT History
                                    {this.renderMotHistoryAction(mot_history, _id)}
                                </h3>
                                <div className="tableWrapper">
                                    {
                                        is_clocked && <p className="ant-alert ant-alert-error margin-bottom-20-px ant-alert-clocked">This bike could have been clocked</p>
                                    }
                                    <div className="profile__contact">
                                        {
                                            !mot_history.length
                                                ? <span style={{ fontStyle: 'italic', width: '100%' }}>There is no MOT data for this bike</span>
                                                : (
                                                    <>
                                                        <Table>
                                                            <thead>
                                                                <tr>
                                                                    {
                                                                        mot_titles.map((title, index) => <th key={index} className="tableHeader">{title}</th>)
                                                                    }
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    cutedMotHistory.map((item, j) => {
                                                                        const wrongMileage = cutedMotHistory[j + 1] && item.mileage < cutedMotHistory[j + 1].mileage;
                                                                        const mileageUnit = item.unit || '';
                                                                        const mileage = item.result === 'RECALL' ? '--' : `${item.mileage} ${mileageUnit}`;
                                                                        return (
                                                                            <Fragment key={j}>
                                                                                <tr key={item._id} style={{ backgroundColor: wrongMileage && '#eb5252' }}>
                                                                                    <td>{item.date_tested && item.date_tested !== '' ? <Moment format="DD MMM YYYY">{item.date_tested}</Moment> : '-'}</td>
                                                                                    <td>{item.result === 'FAILED' || item.result === 'RECALL' ? '--' : <Moment format="DD MMM YYYY">{item.expires}</Moment>}</td>
                                                                                    <td>{mileage}</td>
                                                                                    <td style={{ cursor: 'pointer' }}>
                                                                                        {this.renderResultCell(item)}
                                                                                    </td>
                                                                                </tr>
                                                                                {
                                                                                    item.comment && item.comment.map((i, k) => (
                                                                                        <tr key={k}>
                                                                                            <td colSpan="4" style={{ textAlign: 'left !important' }}>
                                                                                                <strong>{`Advisory ${k + 1}:`}</strong>
                                                                                                <br />
                                                                                                {i.text}
                                                                                            </td>
                                                                                        </tr>
                                                                                    ))
                                                                                }
                                                                            </Fragment>
                                                                        );
                                                                    })
                                                                }
                                                            </tbody>
                                                        </Table>
                                                        {
                                                            hasRecall && (
                                                                <p style={{
                                                                    width: '100%', marginTop: 20, marginBottom: 0, textAlign: 'center',
                                                                }}
                                                                >
                                                                    ⚠️ An outstanding recall exists for this bike. Please check
                                                                    {' '}
                                                                    <a href={`https://www.check-mot.service.gov.uk/results?registration=${encodeURIComponent(bike_details?.vrm || '')}&checkRecalls=true`} target="_blank" rel="noopener noreferrer">gov.uk</a>
                                                                </p>
                                                            )
                                                        }
                                                    </>
                                                )
                                        }
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </div>
            </Spin>
        );
    }
}

MotHistory.propTypes = {
    mot_history: PropTypes.arrayOf(PropTypes.shape({
        _id: PropTypes.string,
        comment: PropTypes.arrayOf(PropTypes.shape({
            text: PropTypes.string,
        })),
        date_tested: PropTypes.string,
        expires: PropTypes.string,
        mileage: PropTypes.number,
        result: PropTypes.string,
        unit: PropTypes.string,
    })),
    _id: PropTypes.string,
    bike_details: PropTypes.shape({
        vrm: PropTypes.string,
    }),
    dispatch: PropTypes.func.isRequired,
    loading: PropTypes.bool,
};

MotHistory.defaultProps = {
    mot_history: null,
    _id: null,
    bike_details: null,
    loading: false,
};

const mapStateToProps = (state) => {
    const { mot_history, loading } = state.Leads.Lead_profile.Lead_mot_history;
    const { bike_details } = state.Leads.Lead_profile.Ref_bike_lead;
    const { _id } = state.Leads.Lead_profile.Lead_general.current_status;
    return {
        mot_history, bike_details, loading, _id,
    };
};

export default connect(mapStateToProps, null)(MotHistory);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_table/MotHistory.js